<template>
  <div>
    <zj-layout-container>
      <div style="height: 48%">
        <div style="width: 50%; height: 100%; float: left">
          <div class="echart">
            <div>
              口碑分数 <linechart :chartData="commentScore"></linechart>
            </div>
          </div>
        </div>
        <div style="width: 50%; height: 100%; float: left">
          <div class="echart">
            <div>口碑数量 <barchart :chartData="commentNum"></barchart></div>
          </div>
        </div>
      </div>
      <div style="height: 50%">
        <div style="width: 50%; height: 100%; float: left">
          <div class="echart">
            <div>
              口碑来源
              <RingPieEchart :chartData="commentSource"></RingPieEchart>
            </div>
          </div>
        </div>
        <div style="width: 50%; height: 100%; float: left">
          <div class="echart">
            <div>
              口碑排名 <barchart2 :chartData="commentScoreRank"></barchart2>
            </div>
          </div>
        </div>
      </div>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import linechart from "@/views/echart/LineEchart";
import barchart from "@/views/echart/BarEchart";
import barchart2 from "@/views/echart/BarEchart2";
export default {
  name: "OpinionScoreView",
  controller: "UI",
  action: "OpinionScoreView",
  components: {
    linechart,
    barchart,
    barchart2,
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      commentScore: {
        days: [],
        data: [],
      },
      commentNum: {
        days: [],
        data: [],
      },
      commentSource: {
        data: [],
      },
      commentScoreRank: {
        days: [],
        data: [],
      },
    };
  },
  mounted: function () {
    //  this.search();

    let searchInfo = {
      CrawlDateFrom: new Date(new Date() - 6 * 24 * 60 * 60 * 1000).format(
        "yyyy-MM-dd 00:00"
      ),
      CrawlDateTo: new Date().format("yyyy-MM-dd 23:59"),
      ProjectName: "景区",
      ProjectType: "旗下景区",
    };
    this.GetAvgScoreByDayTrend(searchInfo);
    this.GetCountByDayTrend(searchInfo);
    this.GetCountByWebSite(searchInfo);
    this.GetCommentScoreRange(searchInfo);
  },
  methods: {
    search() {
      let that = this;
      let searchInfo = {
        BeginTime: new Date(new Date() - 7 * 24 * 60 * 60 * 1000).format(
          "yyyy-MM-dd 00:00"
        ),
        EndTime: new Date(new Date() - 1 * 24 * 60 * 60 * 1000).format(
          "yyyy-MM-dd 23:59"
        ),
      };
      new MyApis.OpinionCommentApi()
        .GetOpinionCommentShow(searchInfo)
        .then((r) => {
          r = r.data.Data;

          that.drawChart(r);
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    //最近7天口碑分数
    GetAvgScoreByDayTrend(searchInfo) {
      let that = this;
      new MyApis.OpinionCommentApi()
        .GetAvgScoreByDayTrend(searchInfo)
        .then((r) => {
          const data = r.data.Data;

          //  that.drawChart(r);

          if (data.OpinionAvgScoreDay && data.OpinionAvgScoreDay.length > 0) {
            const commentScoreDays = [],
              commentScoreData = [];

            data.OpinionAvgScoreDay.forEach((item) => {
              commentScoreDays.push(item.DName);
              commentScoreData.push(item.Count);
            });

            this.commentScore.days = commentScoreDays;
            this.commentScore.data = commentScoreData;
          }
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },

    //最近7天口碑数量
    GetCountByDayTrend(searchInfo) {
      let that = this;
      new MyApis.OpinionCommentApi()
        .GetCountByDayTrend(searchInfo)
        .then((r) => {
          const data = r.data.Data;

          //  that.drawChart(r);

          //最近7天口碑数量
          if (
            data.OpinionCommentCountDay &&
            data.OpinionCommentCountDay.length > 0
          ) {
            const commentCountDays = [],
              commentCountData = [];

            data.OpinionCommentCountDay.forEach((item) => {
              commentCountDays.push(item.DName);
              commentCountData.push(item.Count);
            });

            this.commentNum.days = commentCountDays;
            this.commentNum.data = commentCountData;
          }
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },

    //最近7天口碑来源
    GetCountByWebSite(searchInfo) {
      let that = this;
      new MyApis.OpinionCommentApi()
        .GetCountByWebSite(searchInfo)
        .then((r) => {
          const data = r.data.Data;

          //最近7天口碑来源
          if (data && data.length > 0) {
            data.map((item) => {
              item.name = item.DName;
              item.value = parseInt(item.Count);
            });
            this.commentSource.data = data;
          }
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },

    //最近7天口碑排名
    GetCommentScoreRange(searchInfo) {
      let that = this;
      new MyApis.OpinionCommentApi()
        .GetCommentScoreRange(searchInfo)
        .then((r) => {
          let data = r.data.Data;

          //  that.drawChart(r);

          //最近7天口碑数量
          if (data && data.length > 0) {
            const commentCountDays = [],
              commentCountData = [];
            data = data.slice(0, 10);
            data.forEach((item) => {
              commentCountDays.push(item.DName);
              commentCountData.push(item.Count);
            });

            this.commentScoreRank.days = commentCountDays;
            this.commentScoreRank.data = commentCountData;
          }
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart > div {
  padding: 20px;
  width: 100%;
  height: 100%;
  margin: 0 auto 15px;
  color: #2bc5ff;
  font-weight: bold;
  text-align: center;
  font-size: 20px;
}
</style>